import { render, staticRenderFns } from "./blankPage.vue?vue&type=template&id=64e4cbf1&scoped=true&"
import script from "./blankPage.vue?vue&type=script&lang=js&"
export * from "./blankPage.vue?vue&type=script&lang=js&"
import style0 from "./blankPage.vue?vue&type=style&index=0&id=64e4cbf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e4cbf1",
  null
  
)

export default component.exports